// extracted by mini-css-extract-plugin
module.exports = {"container":"_3112277","active":"_9f7dedd","slide":"_4d5f155"};